import DefaultMainPage from "../../pages/DefaultMainPage";
import Banner from "./Banner";
import Notice from "./Notice";

const noticeMenuItems = [
    {path: "/notice", component: <Banner/>, label: '공지 배너'},
    {path: "/notice/addNotice", component: <Notice/>, label: '공지 생성'},
];

export const noticeRoutes = {
    path: "/notice",
    component: <DefaultMainPage buttons={noticeMenuItems}/>,
   
    children: noticeMenuItems
}